export default "__VITE_ASSET__CIg6SCZV__"